// extracted by mini-css-extract-plugin
module.exports = {"formDetailsPreviewPage":"FormDetailsPreviewPage_formDetailsPreviewPage__WFViM"};